import './styles.scss'

import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import useEvent from 'src/hooks/useEvent'
import useHub from 'src/hooks/useHub'
import { isTGACustomer } from 'src/utils/specialCustomers'

const Footer = () => {
  const { t } = useTranslation('footer')
  const history = useHistory()

  // const id = history.location.pathname.split('/events/')[1]?.split('?')[0].split('/')[0]
  // const { event } = useEvent(id, {
  //   retry: 0,
  //   enabled:
  //     id != null && id !== 'list' && id !== 'upcoming' && id !== 'past' && id !== 'favorites' && id !== 'unfinished',
  // })

  // const clubId = history.location.pathname.split('/clubs/')[1]?.split('?')[0].split('/')[0]

  // let hubId = history.location.pathname.split('/hubs/')[1]?.split('?')[0].split('/')[0]
  // if (id != null && hubId == null) {
  //   hubId = document.referrer?.split('/hubs/')[1]?.split('?')[0].split('/')[0]
  // }
  // const { hub } = useHub({ id: hubId }, { retry: 0, enabled: hubId != null })

  const isTwilightFacilityRoute = /^\/facilities\//.test(history.location.pathname)
  let isFooterHidden =
    ['preview-event', 'test'].some((route) => history.location.pathname.includes(route)) || window
      ? 'parentIFrame' in window
      : false

  // if (!isFooterHidden) {
  //   isFooterHidden = isTGACustomer(hub?.id) || isTGACustomer(clubId) || isTGACustomer(event?.customer_id)
  // }

  const GOLFGENIUS_URL = process.env.REACT_APP_BASE_URL == 'prod' ? 'https://www.golfgenius.com' : 'https://ggstest.com'

  return (
    <Fragment>
      <footer className="golf-footer" style={{ display: isTwilightFacilityRoute || isFooterHidden ? 'none' : 'block' }}>
        <div className="golf-container d-flex flex-wrap pb-40">
          <div className="is-1-of-1 tablet:is-1-of-5 d-none tablet:d-flex mb-32 tablet:mb-0 pr-40">
            <div className="golf-footer__logo--orange"></div>
          </div>
          <div className="is-1-of-2 tablet:is-1-of-5">
            <ul className="golf-footer__links-wrapper">
              <li className="golf-footer__list-title">
                <p className="text-14 sm_desktop:text-19">{t('sections.products')}</p>
              </li>
              <li>
                <a href={`${GOLFGENIUS_URL}/tm`} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.tournamentManagement')}</span>
                </a>
              </li>
              <li>
                <a href={`${GOLFGENIUS_URL}/golfshop`} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.golfShop')}</span>
                </a>
              </li>
              <li>
                <a href={`${GOLFGENIUS_URL}/coach360`} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.coach360')}</span>
                </a>
              </li>
              <li>
                <a
                  href={
                    'https://operation36.golf/coaches/?utm_source=golfgenius&utm_medium=referral_link&utm_campaign=golfgeniushomepage'
                  }
                  className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.operation36')}</span>
                </a>
              </li>
              <li>
                <a href={'https://coachnow.io'} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.coachNow')}</span>
                </a>
              </li>
              <li>
                <a href={`${GOLFGENIUS_URL}/trip-manager`} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.tripManager')}</span>
                </a>
              </li>
              <li>
                <a
                  href={'https://www.twilightgolfassociation.com'}
                  className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.twilightGolf')}</span>
                </a>
              </li>
              <li>
                <a href={'https://golfshot.com'} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.golfshot')}</span>
                </a>
              </li>
              <li>
                <a href={'https://swingu.com'} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.swingU')}</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="is-1-of-2 tablet:is-1-of-5">
            <ul className="golf-footer__links-wrapper">
              <li className="golf-footer__list-title">
                <p className="text-14 sm_desktop:text-19">{t('sections.company')}</p>
              </li>
              <li>
                <a href={`${GOLFGENIUS_URL}/our-mission`} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.aboutUs')}</span>
                </a>
              </li>
              <li>
                <a href={`${GOLFGENIUS_URL}/about-us`} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.executiveTeam')}</span>
                </a>
              </li>
              <li>
                <a href={`${GOLFGENIUS_URL}/news`} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.news')}</span>
                </a>
              </li>
              <li>
                <a href={`${GOLFGENIUS_URL}/partners`} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.partners')}</span>
                </a>
              </li>
              <li>
                <a
                  href={'https://share.hsforms.com/1ggHh0W3IRJGhKuC_NUbnwAqm7oy'}
                  target="_blank"
                  rel="noreferrer"
                  className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.contactUs')}</span>
                </a>
              </li>
              <li>
                <a
                  href={`${GOLFGENIUS_URL}/resources/advertising`}
                  className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.advertising')}</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="is-1-of-2 tablet:is-1-of-5">
            <ul className="golf-footer__links-wrapper">
              <li className="golf-footer__list-title">
                <p className="text-14 sm_desktop:text-19">{t('sections.social')}</p>
              </li>
              <li>
                <a
                  href={'https://www.facebook.com/GolfGeniusSoftware/'}
                  target="_blank"
                  rel="noreferrer"
                  className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.facebook')}</span>
                </a>
              </li>
              <li>
                <a
                  href={'https://x.com/GolfGenius'}
                  target="_blank"
                  rel="noreferrer"
                  className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.twitter')}</span>
                </a>
              </li>
              <li>
                <a
                  href={'https://www.linkedin.com/company/5014111/'}
                  target="_blank"
                  rel="noreferrer"
                  className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.linkedin')}</span>
                </a>
              </li>
              <li>
                <a
                  href={'https://www.instagram.com/golfgeniussoftware/?hl=en'}
                  target="_blank"
                  rel="noreferrer"
                  className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.instagram')}</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="is-1-of-2 tablet:is-1-of-5">
            <ul className="golf-footer__links-wrapper">
              <li className="golf-footer__list-title">
                <p className="text-14 sm_desktop:text-19">{t('sections.legal')}</p>
              </li>
              <li>
                <a href={`${GOLFGENIUS_URL}/terms_conditions`} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.termsOfService')}</span>
                </a>
              </li>
              <li>
                <a href={`${GOLFGENIUS_URL}/privacy`} className="golf-footer__link text-14 sm_desktop:text-19">
                  <span>{t('links.privacyPolicy')}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <small className="d-none sm_tablet:d-block text-right text-dark-grey">
          {t('copyright', { year: new Date().getFullYear() })}
        </small>
      </footer>
    </Fragment>
  )
}

export default Footer
